// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ho25","controls":"styles_controls__1LPM7","charLimit":"styles_charLimit__2ZQtk","input":"styles_input__2h5bH","send":"styles_send__1Klfl"};